module.exports = "pegasus/assets/social-1-basic.png";